import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../components/button'
import Headline5 from '../../components/headings/Headline5'
import Modal from '../../components/modal'
import { MultiDropDownInput } from '../../wrappers/multiselectInput'
import { DropDownInput } from '../../wrappers/selectInput'
import DatepickerDefault from "../../components/daterangePicker"
import { getMilliSecUTC } from "../../utils/EllowUtils"
import * as CONSTANTS from '../../utils/CONSTANTS'

export type CandidateTimesheetFilterForm = {
    positionName?: any
    company?: any
    status?: any
    dateWithin: any
    invoiceRaised?: string
    month?: string
    year?: string
    candidateType?: string
}

interface props {
    clickHandler: any
    defaultValues?: any
    onClose: any
    positionName: any
    companyNames: any
    type: any
}

const CandidateTimesheetFilter: React.FC<props> = ({
    clickHandler,
    defaultValues,
    onClose,
    positionName,
    companyNames,
    type
}) => {

    const formOptions = {}
    
    const { register, handleSubmit, control, reset, setValue, formState } =
    useForm<CandidateTimesheetFilterForm>(formOptions);

    useEffect(() => {  
        
        if(defaultValues){
            reset(defaultValues)
        }  
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[defaultValues])

    const onSubmit = (data: any) => { clickHandler(data) }

    const handleChange = (e: any, name: string) => {
        if (name === "dateChange") {
            let dateWithin = {
              from: getMilliSecUTC(e.target.value.start),
              to: getMilliSecUTC(e.target.value.end),
            }
            setValue("dateWithin", dateWithin);
        }
    }
 

return (
    <Modal title='companysheetFilter' size='medium' onClose={onClose}>
        <form>
        <Headline5>Candidate Timesheet Filter</Headline5>
        {type === 'candidateTimesheet' &&
            <div className="form-group">
                <label className="lablel">Company Name</label>
                <MultiDropDownInput<CandidateTimesheetFilterForm>
                    name='company'
                    placeholder="Select Company name"
                    data={companyNames}
                    register={register}
                    control={control}
                />
            </div>
        }
        <div className="form-group">
            <MultiDropDownInput<CandidateTimesheetFilterForm>
                name="positionName"
                placeholder="Select Positions"
                label="Positions"
                register={register}
                data={positionName}
                errors={formState.errors}
                defaultValue={defaultValues && defaultValues.positionName}
                control={control}
                allowCustom={false}
            />
        </div> 
        <div className="half-form-wrap">
            <div className="form-group">
                <label className="lablel">Status</label>
                <MultiDropDownInput<CandidateTimesheetFilterForm>
                    name='status'
                    placeholder="Select Timesheet status"
                    register={register}
                    control={control}
                    textField='name'
                    dataItemKey='id'
                    allowCustom={false}
                    data={[{name: 'Draft', id: 1},{name: 'Submitted', id: 2},{name: 'Approved', id: 3},{name: 'Rejected', id: 4}]}
                />
            </div>      
            <div className="form-group">
                <label className="lablel">Invoice raised</label>
                <DropDownInput<CandidateTimesheetFilterForm>
                    name='invoiceRaised'
                    data={[{name: 'Yes', id: 0},{name: 'No', id: 1}]}
                    register={register}
                    control={control}
                    textField='name'
                    dataItemKey='id'         
                />
            </div>
        </div>
        <label className="lablel">Contract Duration</label>
        <div className="half-form-wrap">
            <div className="form-group">
                <DropDownInput<CandidateTimesheetFilterForm>
                    name='month'
                    data={CONSTANTS.months}
                    register={register}
                    control={control}    
                    label={'Month'}    
                />
            </div>   
            <div className="form-group">
                <DropDownInput<CandidateTimesheetFilterForm>
                    name='year'
                    data={CONSTANTS.years}
                    register={register}
                    control={control}     
                    label={'Year'}    
                />
            </div>      
        </div>
        <label className="lablel">Submitted on</label>
        <div className="half-form-wrap">
            <div className="form-group">
                <DatepickerDefault
                    onChange={(e: any) => handleChange(e, "dateChange")}
                />
            </div>
            <div className="form-group">
                <DropDownInput<CandidateTimesheetFilterForm>
                    name="candidateType"
                    label="Candidate type"
                    register={register}
                    data={['Service Provider', 'Individual']}
                    errors={formState.errors}
                    control={control}
                />
        </div>
        </div>
        <div className="popupAction">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handleSubmit(onSubmit)}>Apply Filter</Button>
        </div>
    </form>
    </Modal>
  )
}
export default CandidateTimesheetFilter